/** Indian mobile: exactly 10 digits, first digit 6–9 */
export const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;

export function isValidIndianMobile(value) {
    return typeof value === "string" && INDIAN_MOBILE_REGEX.test(value.trim());
}

/**
 * Strips non-digits, normalizes optional +91 prefix to 10 digits, then keeps a valid
 * prefix (starts with 6–9, max 10 digits).
 */
export function sanitizeIndianMobileInput(raw) {
    let digits = String(raw).replace(/\D/g, "");
    if (digits.length > 10) {
        digits = digits.slice(-10);
    }
    if (digits.length === 0) return "";
    const match = digits.match(/^[6-9]\d{0,9}/);
    return match ? match[0].slice(0, 10) : "";
}

export function isProbablyValidEmail(value) {
    const s = String(value || "").trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}

/** Required: name, email, valid Indian mobile. Optional fields ignored. */
export function canSubmitEnquiryForm({ name, email, phone }) {
    const n = String(name || "").trim();
    const p = sanitizeIndianMobileInput(phone);
    return n.length > 0 && isProbablyValidEmail(email) && isValidIndianMobile(p);
}
